export default "__VITE_ASSET__BP7LMjKb__"